import { Route, Router, Switch } from "wouter";
import { Home } from "./pages/home/Home";
import { SearchResult } from "./pages/search-result/SearchResult";
import { ProviderProfile } from "./pages/provider-profile/ProviderProfile";
import "./index.css"
import { Login } from "./pages/login/Login";
import { Register } from "./pages/register/Register";
import Admin from "./components/admin/Admin";
import HomeDriver from "./pages/HomeDriver/HomeDriver";
import TermsAndConditions from "./pages/TermAndConditions/TermAndConditions";
import PrivacyPolicy from "./pages/Privacity/Privacity";

function App() {
  return (
    <div>


      <Switch>


        <Router>
          <Route path={"/"} component={HomeDriver} />
          <Route path={"/terms"} component={TermsAndConditions} />
          <Route path={"/privacity"} component={PrivacyPolicy} />
          <Route path={"/search"} component={SearchResult} />
          <Route path={"/provider-profile/:id"} component={ProviderProfile} />
          <Route path={"/login"} component={Login} />
          <Route path={"/register"} component={Register} />
          <Route path={"/panel"} component={Admin} />
        </Router>
      </Switch>
    </div>
  );
}

export default App;
